export const createEventEmitter: () => EventEmitter = () => {
  let lastArgs: Array<any> = [];
  let subscribers: Array<SubscribeFunc> = [];
  let emitter: EventEmitter = {
    emit(...args: Array<any>) {
      lastArgs = args;
      subscribers.forEach(subscriber => subscriber(...args));
    },

    subscribe(subscriber: SubscribeFunc, useLastEmit?: boolean) {
      let lastEmit: boolean = !!useLastEmit;
      if (!subscribers.includes(subscriber)) {
        subscribers.push(subscriber);
        if (lastArgs?.length > 0 && lastEmit) {
          subscriber(...lastArgs);
        }
      }

      return () => (subscribers = subscribers.filter(x => x !== subscriber));
    }
  };
  return emitter;
};

export interface EventEmitter {
  emit(...args: Array<any>): void;
  subscribe(subscriber: any, useLastEmit?: boolean): () => void;
}

export interface SubscribeFunc {
  (...args: Array<any>): void;
}
